<script setup lang="ts">
import BaseAsset from './BaseAsset.vue';
import { NetworkIdType, networks } from '@sonarwatch/portfolio-core';
import { computed } from 'vue';
import { useDataStore } from '@/store/data';
const store = useDataStore();
const props = defineProps<{
  address: string;
  networkId: NetworkIdType;
  hideLabel?: boolean;
  showNetwork?: boolean;
  imageSize?: number | string;
}>();

const tokenInfo = computed(() =>
  store.getTokenInfo(props.address, props.networkId),
);
const image = tokenInfo.value?.logoURI;
const label = tokenInfo.value?.symbol || 'UNK';
const networkImage = computed(() =>
  props.showNetwork ? networks[props.networkId].image : undefined,
);
</script>

<template>
  <BaseAsset
    :text-to-copy="address || undefined"
    :images="[image]"
    :hide-label="hideLabel"
    :label="label"
    :badge-image="networkImage"
    :imageSize="imageSize"
  />
</template>
